<app-navbar></app-navbar>
<div [ngClass]="!_bannerService.isErrorPage ? 'container_page' : ''">
	<div [class.container__content__page]="!_bannerService.isErrorPage">
		<app-sidebar *ngIf="!_bannerService.isErrorPage"></app-sidebar>
		<router-outlet></router-outlet>
	</div>
</div>
<app-footer class="footer"></app-footer>
